export enum PageName {
  DEPLOY_SW = 'DEPLOY SW',
  DEPLOY_DS = 'DEPLOY DS',
  RUN_TILES = 'RUN TILES',
  MODEL_BUILD = 'MODEL_BUILD',
  BENCHMARK_RUN = 'BENCHMARK_RUN',
  MAPPING = 'MAPPING'
}
